// Náhled za uživatele (docs/08-autorizace.md §1 bod 9): POST /nahled/start a /nahled/stop.
// Kdo za koho smí, rozhoduje server; po změně se vždy znovu načte GET /ja (jiná role, jiné menu).
import type { operations } from '@ecoser/shared';
import type { QueryClient } from '@tanstack/react-query';
import { zapomenBalicek } from '../offline/balicek';
import { KLIC_JA } from './ja';
import { api } from './klient';

export type NahledStartOdpoved = NonNullable<
  operations['nahledStart']['responses'][200]['content']['application/json']
>;

/** Začne náhled za zaměstnance `zamestnanecId` (admin/jednatel za kohokoli, dispečer za řidiče a skladníka). */
export function zacitNahled(zamestnanecId: string): Promise<NahledStartOdpoved> {
  return api.post<NahledStartOdpoved>('/nahled/start', { zamestnanec_id: zamestnanecId });
}

/** Ukončí náhled (server zapíše `impersonace_stop`). */
export function ukoncitNahled(): Promise<void> {
  return api.post<void>('/nahled/stop');
}

/**
 * Po začátku i konci náhledu je přihlášený někdo jiný: všechna načtená data (seznamy, Můj den, karty, zvonek)
 * patří předchozí identitě. Zahodí je a aktivní dotazy načte znovu — jinak obrazovka ukazovala data náhledu,
 * dokud uživatel neklikl jinam nebo neobnovil stránku (zadavatel 28. 9. 2026). Samotné `/ja` se jen invaliduje:
 * starý profil zůstane do příchodu nového, ať aplikace mezitím nepřepne na přihlášení.
 */
export async function obnovitPoZmeneIdentity(queryClient: QueryClient): Promise<void> {
  const jeJa = (klic: readonly unknown[]) =>
    klic.length === KLIC_JA.length && klic[0] === KLIC_JA[0];
  await zapomenBalicek();
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: KLIC_JA, exact: true }),
    queryClient.resetQueries({ predicate: (q) => !jeJa(q.queryKey) }),
  ]);
}
